<script setup lang="ts"></script>
<template>
  <SidebarBlock variant="white" :heading-text="$t('widget.customer_care_nbkr.heading')">
    <p class="mb-3 text-sm leading-4">
      {{ $t('widget.customer_care_nbkr.text') }}
    </p>
    <div class="rounded-md bg-gray-100 p-3 text-sm leading-4">
      <p class="mb-1 text-gray-600">{{ $t('widget.customer_care_nbkr.schedule') }}</p>
      <a href="tel:+996312610486" class="font-serif font-bold text-blue-600 hover:underline">
        +996 (312) 61-04-86
      </a>
    </div>
  </SidebarBlock>
</template>
